import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useEnableProductNfceMapping } from '@/features/productNfceMappings/hooks/useEnableProductNfceMapping'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

interface EnableProductNfceMappingModalProps {
  productNfceMappingId: string
  disabled?: boolean
}

export const EnableProductNfceMappingModal = ({
  productNfceMappingId,
  disabled,
}: EnableProductNfceMappingModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: enableMapping, isPending } = useEnableProductNfceMapping({
    productNfceMappingId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productNfceMappings'] })
      queryClient.invalidateQueries({ queryKey: ['productNfceMapping', productNfceMappingId] })
      setIsOpen(false)
    },
    onError: (error) => {
      setIsOpen(false)
      const errorMessages = (error as any)?.response?.data?.errors?.base
      if (errorMessages) {
        setMessages(errorMessages)
      }
    },
  })

  return (
    <>
      <Modal
        Trigger={
          <Button
            operationKlassToCheckPermission="Admin::ProductNfceMappings::Enable"
            type="button"
            variant="outline-success"
            disabled={disabled}
          >
            Habilitar
          </Button>
        }
        title="Habilitar mapeamento"
        subtitle="Tem certeza que deseja habilitar este mapeamento de produto NFCe?"
        subtitleClassName="mt-1 text-white-300"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Confirmar"
        confirmButtonIsLoading={isPending}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={() => enableMapping()}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
